'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportsUsageService = function () {
    function ReportsUsageService($http, appConfig) {
        "ngInject";

        (0, _classCallCheck3.default)(this, ReportsUsageService);
        this._$http = $http;
        this._appConfig = appConfig;
    }

    (0, _createClass3.default)(ReportsUsageService, [{
        key: 'getReportsBreakdownByBrand',
        value: function getReportsBreakdownByBrand(criteria) {
            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/GetReportsBreakdownByBrand/', criteria);
        }
    }, {
        key: 'getReportsBreakdownByLocation',
        value: function getReportsBreakdownByLocation(criteria) {
            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbylocation/', criteria);
        }
    }, {
        key: 'getReportsBreakdownByType',
        value: function getReportsBreakdownByType(criteria) {
            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbytype/', criteria);
        }
    }, {
        key: 'getReportsBreakdownByOutputType',
        value: function getReportsBreakdownByOutputType(criteria) {
            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbyoutputtype/', criteria);
        }
    }, {
        key: 'getReportsBreakdownBySalesPerson',
        value: function getReportsBreakdownBySalesPerson(criteria) {
            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbysalesperson/', criteria);
        }
    }]);
    return ReportsUsageService;
}();

exports.default = ReportsUsageService;


// WEBPACK FOOTER //
// ./client/app/components/reports/adminReports/reportsUsage/reportsUsage.service.js